import { IS_SERVER } from '@af-app/config';
import ImageWrapper from '@af-create/Webgl/ImageWrapper';
import * as Resources from './Resources';
//@ts-ignore
import { getPixels } from 'get-pixels';

export type Image = {
	id: string,
	name: string,
	src: string,
	width?: number,
	height?: number,
}

export default class ImageLibrary extends Resources.Lib<Image> {
	protected crossOrigin:string = 'use-credentials';

	public flush = () => {
		this.contents = [];
		this.map = {};
	}

	public retrieve = (image:Image, full:boolean = false):Promise<Image> => {
		return this.retrieveImage(image, full);
	}

	public retrieveImage = (image:Image, full:boolean):Promise<Image> => {
		return new Promise((resolve, reject) => {
			let resource:Resources.Resource;
			
			if(this.map.hasOwnProperty(image.id)){
				resource = this.contents[this.map[image.id]];
			} else {
				let imagenode = document.createElement('img');
				imagenode.crossOrigin = this.crossOrigin;
				resource = {id:image.id, value: ImageWrapper.fromImage(imagenode), status: Resources.STATUS_NONE, extra: {width: image.width, height: image.height}}
				this.map[image.id] = this.contents.length;
				this.contents[this.map[image.id]] = resource;
			}

			resource.value.content.onload = () => {
				resource.status = Resources.STATUS_SUCCESS;
				resolve(image);
			};

			resource.value.content.onerror = () => {
				resource.status = Resources.STATUS_ERROR;
				reject("Error loading image " + resource.value.src);
			}

			switch(resource.status){
				case Resources.STATUS_NONE:
					resource.status = Resources.STATUS_FETCHING;
					resource.value.content.src = image.src;
					break;
				case Resources.STATUS_SUCCESS:
					resolve(image);
					break;
				case Resources.STATUS_ERROR:
					reject("Error loading image " + resource.value.content.src);
					break;
			}
		});
	}
	
	public remove = (id:string):Promise<string> => {
		return new Promise((resolve, reject) => {
			// if(!this.map.hasOwnProperty(id)) reject("Error image not found");
			this.contents[this.map[id]] = null;
			delete this.map[id];
			resolve(id);
		});
	}
}